<!--Footer Component-->
<template>
    <footer class="footer bg-dark text-light">
      <div class="container text-center">
        <span >@TechBlog</span>
      </div>
    </footer>
</template>
  
<script>
  export default {
    name: 'PageFooterComponent'
  }
</script>
  
<style scoped>
  .footer {
    padding: 1rem 0;
    background-color: #000;
    color: #d3d3d3;
  }
</style>
  